<template>
  <div >
    <cms-section
      v-for="menuItem in content.children"
      :key="menuItem.id"
      :section="{ name: menuItem.id, items: [{ ...menuItem, isFullWidth: true }] }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { MegaMenuContent } from '#types/components/cms/mega-menu'
import { MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{
  content: MegaMenuContent
}>()

provide(MegaMenuMobileContextKey, true)
</script>
